export const 업체명 = '미스터 디벨로';
export const 전화번호 = '070-8860-0092';
export const 대표자명 = '송익주';
export const 사업자등록번호 = '507-87-02801';
export const 주소 = '서울 마포구 동교로 156-4 B1';
export const 정보책임자 = '우요한';
export const 이메일 = 'contact@mrdevello.com';
export const COPYRIGHT =
	'COPYRIGHTS (C) 2025. 미스터디벨로. \nALL RIGHTS RESERVED.';
export const 개인정보처리방침시행일 = '2023년 01월 30일';
